export const selectHistoricalTemplates = (state) => state.history.templates

export const selectHistoricalSearches = (state) => state.history.searches

export const selectHistoricalResources = (state) => state.history.resources
